import { render } from "./AmplifyCollectionSettings.vue?vue&type=template&id=14dfb249"
import script from "./AmplifyCollectionSettings.vue?vue&type=script&lang=js"
export * from "./AmplifyCollectionSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__